module.exports = __webpack_public_path__ + "assets/map-marker.54b4c704.svg";